import type { RewardType } from "shared/schema";
import { Page, useNavigator } from "shared/react";
import { CreatorAssertion } from "./CreatorAssertion.js";
import { useCreatorContext } from "./CreatorContext.js";
import { RewardCreateForm } from "./RewardForm.js";

function RewardCreatePage({ type }: { type: RewardType }): React.ReactElement {
	const creator = useCreatorContext();
	const nav = useNavigator();
	return (
		<Page title={`Create ${type}`} path={`./types/new`}>
			<CreatorAssertion creator={creator} />
			<header>
				<h1>{`Create ${type}`}</h1>
			</header>
			<RewardCreateForm
				type={type}
				onReward={id => {
					nav.redirect(`/reward/${id}`);
				}}
				data={{ creator }}
			/>
		</Page>
	);
}

export function BadgeCreatePage(): React.ReactElement {
	return <RewardCreatePage type="badge" />;
}

export function BackgroundCreatePage(): React.ReactElement {
	return <RewardCreatePage type="background" />;
}

export function ReactionCreatePage(): React.ReactElement {
	return <RewardCreatePage type="reaction" />;
}
